<template>
  <div>
    <naj-box :title="local.caseRelatedRequest.relatedPartyInfo">
      <div class="pa-3 content-wrapper">
        <naj-input
          :type-id="formFieldType.selectbox"
          :value.sync="formModel.applicantCasePartyId"
          :label="local.caseRelatedRequest.relatedPartyInfo"
          :items="prosecutorsCaseParties"
          item-value="casePartyId"
          item-text="name"
          validates="required"
          :disabled="casePartiesSelectboxDisabled"
        ></naj-input>
      </div>
    </naj-box>

    <naj-box
      v-if="isLoggedInUserCasePartyDefendant"
      :title="local.caseRelatedRequest.litigationAbandonmentsRequest.requestTemplate"
    >
      <v-form
        v-if="defendantCanReply"
        ref="defendantResponseFormRef"
        @submit.prevent="saveDefendantResponse"
      >
        <v-row v-if="isLoggedInUserCasePartyAgentOrRepresentative">
          <v-col cols="6">
            <naj-input
              :type-id="formFieldType.selectbox"
              :label="local.caseRelatedRequest.litigationAbandonmentsRequest.onBehalfOf"
              :value.sync="litigationAbandonmentDefendantCasePartyId"
              :items="defendantsWithNoReply"
              item-value="defendantCasePartyId"
              item-text="fullName"
              validates="required"
              @change="setLitigationAbandonmentRecord"
            ></naj-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <naj-input
              :type-id="formFieldType.radioButton"
              :label="local.caseRelatedRequest.litigationAbandonmentsRequest.defendantResponseMessage"
              :value.sync="defendantResponse"
              :items="acceptOrRefuse"
              item-value="id"
              item-text="name"
              validates="required"
            ></naj-input>
          </v-col>
        </v-row>
      </v-form>
      <v-row>
        <v-col cols="12">
          <naj-data-table
            no-header
            :headers="headers"
            :loading="loading"
            :items="defendantsNames"
            :disable-items-per-page="true"
            no-margin-bottom
          >
          </naj-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="text-left"
        >
          <naj-button
            outlined
            @click="$router.back()"
          >
            {{ local.common.back }}
          </naj-button>

          <naj-button
            v-if="defendantCanReply"
            @click="saveDefendantResponse"
          >
            {{ local.caseRelatedRequest.litigationAbandonmentsRequest.sendResponse }}
          </naj-button>
        </v-col>
      </v-row>
    </naj-box>
    <naj-box
      v-else
      :title="local.caseRelatedRequest.litigationAbandonmentsRequest.title"
    >
      <v-row>
        <v-col cols="6">
          <naj-input
            :type-id="formFieldType.multipleSelectBox"
            :value.sync="formModel.DefendantsCasePartiesOfAbandonments"
            :label="local.caseRelatedRequest.litigationAbandonmentsRequest.defendantName"
            :items="defendants"
            item-value="casePartyId"
            item-text="name"
            validates="required"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>
  </div>
</template>

<script>
import { mode, casePartyRoleEnum, partyTypeEnum, casePartyStatus, litigationAbandonmentDefendantsResponseText, litigationAbandonmentDefendantsResponseEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('CasesModule');
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');

export default {
  name: 'LitigationAbandonmentsRequest',
  inject: ['$validator'],
  components: {},
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      caseParties: [],
      defendants: [],
      isLoggedInUserExistsAsCaseParty: false,
      userCasePartyRoleInCase: {},
      isLoggedInUserCasePartyDefendant: false,
      isLoggedInUserCasePartyAgentOrRepresentative: false,
      defendantResponse: null,
      defendantsNames: [],
      defendantsWithNoReply: [],
      litigationAbandonment: null,
      basicCasePartiesInfo: [],
      litigationAbandonmentDefendantCasePartyId: null,
      headers: [
        {
          value: 'index',
          text: '#',
        },
        {
          value: 'fullName',
          text: this.local.caseRelatedRequest.litigationAbandonmentsRequest.defendant,
        },
        {
          value: 'response',
          text: this.local.caseRelatedRequest.litigationAbandonmentsRequest.defendantResponse,
        },
        {
          value: 'defendantResponseDate',
          text: this.local.caseRelatedRequest.litigationAbandonmentsRequest.defendantResponseDate,
        },
      ],
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    ...mapLUTState(['acceptOrRefuse']),
    prosecutorsCaseParties() {
      return (this.caseParties || []).filter(cp => cp.casePartyRole == casePartyRoleEnum.prosecutor);
    },
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
    casePartiesSelectboxDisabled() {
      return this.isViewMode || (this.formModel.applicantCasePartyId && this.isLoggedInUserExistsAsCaseParty);
    },
    defendantCanReply() {
      return (this.litigationAbandonment && this.litigationAbandonment.defendantResponse == litigationAbandonmentDefendantsResponseEnum.noReply)
        || this.defendantsWithNoReply.length > 0;
    },
  },
  watch: {},
  mounted() {
    this.loading = true;
    const params = {
      isPega: this.formModel.isPega,
      objectKey: this.formModel.case.objectKey,
    };
    Promise.all([
      this.getCaseRequestApplicants(params),
      this.getUserCasePartyRoleInCase(params),
      this.getCaseBasicParties(params),
    ])
      .then((res) => {
        this.caseParties = !this.isViewMode ? res[0].data.requestApplicants : [...res[0].data.prosecutors, ...res[0].data.defendants];
        this.defendants = !this.isViewMode ? res[0].data.defendants.filter(cp => !cp.casePartyStatusId || cp.casePartyStatusId == casePartyStatus.active) : res[0].data.defendants;
        this.userCasePartyRoleInCase = res[1].data;
        this.basicCasePartiesInfo = res[2].data;
        this.checkIfUserIsCasePartyProsecutor(); // get the original case party and check if he/she is prosecutor or not
        this.setRelatedPartyAsRequestApplicant();
        this.autoSelectDefendant();
        if (this.isViewMode && this.isLoggedInUserCasePartyDefendant) {
          if (this.isLoggedInUserCasePartyAgentOrRepresentative) {
            this.showAgentOrRepresentativeLitigationAbandonmentDefendants();
          }
          else {
            this.showOtherDefendantsPreviousResponses();
          }
        }
      })
      .finally(() => (this.loading = false));
  },
  created() {
    if (!this.formModel.DefendantsCasePartiesOfAbandonments
      && !this.isEditMode
      && !this.isViewMode
      && !this.isLoggedInUserCasePartyDefendant) {
      this.$set(this.formModel, 'DefendantsCasePartiesOfAbandonments', []);
    }
  },
  methods: {
    ...mapActions([
      'getCaseRequestApplicants',
      'getUserCasePartyRoleInCase',
      'getLitigationAbandonmentDefendants',
      'saveLitigationAbandonmentDefendantResponse',
      'getCaseBasicParties',
    ]),
    setLitigationAbandonmentRecord() {
      this.litigationAbandonment = this.defendantsWithNoReply.find(d => d.defendantCasePartyId == this.litigationAbandonmentDefendantCasePartyId) || {};
    },
    mapDefendantsNames(defendantsData) {
      return defendantsData.map(defendant => ({
        ...defendant,
        response: litigationAbandonmentDefendantsResponseText[defendant.defendantResponse],
      }));
    },
    showAgentOrRepresentativeLitigationAbandonmentDefendants() {
      this.getLitigationAbandonmentDefendants(this.formModel.id) //requestId
        .then((result) => {
          const loggedInUserCaseParties = this.basicCasePartiesInfo.filter(a => a.partyId == this.userCasePartyRoleInCase.partyId);

          let currentUserRelatedCaseParties = this.basicCasePartiesInfo.filter(cp => cp.casePartyRole === casePartyRoleEnum.defendant
            && loggedInUserCaseParties.some(p => p.relatedCasePartyID == cp.casePartyId));

          this.defendantsWithNoReply = result.data.filter(x => x.defendantResponse === litigationAbandonmentDefendantsResponseEnum.noReply
            && currentUserRelatedCaseParties.some(p => p.casePartyId === x.defendantCasePartyId)) || [];
          this.defendantsNames = this.mapDefendantsNames(result.data);
        });
    },
    showOtherDefendantsPreviousResponses() {
      this.getLitigationAbandonmentDefendants(this.formModel.id) //requestId
        .then((result) => {
          this.litigationAbandonment = result.data.find(x => x.defendantCasePartyId === this.userCasePartyRoleInCase.casePartyId) || {};
          this.defendantsNames = this.mapDefendantsNames(result.data);
        });
    },
    saveDefendantResponse() {
      this.$refs.defendantResponseFormRef.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            this.loading = true;
            const payload = {
              litigationAbandonmentsId: this.litigationAbandonment.id,
              prosecutorCasePartyId: this.litigationAbandonment.prosecutorCasePartyId,
              defendantCasePartyId: this.litigationAbandonment.defendantCasePartyId,
              defendantResponse: this.defendantResponse,
              requestObjectKey: this.formModel.objectKey,
            };
            this.saveLitigationAbandonmentDefendantResponse(payload)
              .then(() => {
                this.$router.push({ path: '/' });
              })
              .finally(() => (this.loading = false));
          }
        });
    },
    autoSelectDefendant() {
      if (!this.isEditMode && !this.isViewMode && !this.isLoggedInUserCasePartyDefendant && this.defendants.length == 1) {
        const casePartyId = this.defendants[0].casePartyId;
        this.$set(this.formModel, 'DefendantsCasePartiesOfAbandonments', [casePartyId]);
      }
    },
    setRelatedPartyAsRequestApplicant() {
      const selectedParty = this.prosecutorsCaseParties.find(cp => cp.partyId == this.userCasePartyRoleInCase.partyId);
      if (selectedParty) {
        this.isLoggedInUserExistsAsCaseParty = true;
        this.$set(this.formModel, 'applicantCasePartyId', this.formModel.applicantCasePartyId || selectedParty.casePartyId);
      }
    },
    checkIfUserIsCasePartyProsecutor() {
      if (this.userCasePartyRoleInCase.roleInCaseId == casePartyRoleEnum.prosecutor) {
        this.isLoggedInUserCasePartyDefendant = false;
      } else if (this.userCasePartyRoleInCase.roleInCaseId == casePartyRoleEnum.defendant) {
        this.isLoggedInUserCasePartyDefendant = true;
      } else {
        // case party is agent or representative
        this.isLoggedInUserCasePartyAgentOrRepresentative = true;
        let basicCasePartyRoles = [casePartyRoleEnum.prosecutor, casePartyRoleEnum.defendant];
        let currentUserCaseParties = this.basicCasePartiesInfo.filter(cp => cp.partyId == this.userCasePartyRoleInCase.partyId
          && !basicCasePartyRoles.some(b => b == cp.casePartyRole) && !!cp.relatedCasePartyID);

        for (const item of currentUserCaseParties) {
          var relatedCaseParty = this.getBasicCaseParty(item.relatedCasePartyID);
          if (relatedCaseParty && relatedCaseParty.casePartyRole == casePartyRoleEnum.defendant) {
            this.isLoggedInUserCasePartyDefendant = true;
          }
        }
      }
    },
    getBasicCaseParty(relatedCasePartyId) {
      var basicCaseParty = this.basicCasePartiesInfo.find(b => b.casePartyId == relatedCasePartyId);
      let basicCasePartyRoles = [casePartyRoleEnum.prosecutor, casePartyRoleEnum.defendant];
      if (!basicCaseParty) {
        return null;
      }
      if (basicCaseParty && basicCaseParty.partyType == partyTypeEnum.person && basicCasePartyRoles.some(b => b == basicCaseParty.casePartyRole)) {
        return basicCaseParty;
      } else if (basicCaseParty.partyType != partyTypeEnum.person) {
        return basicCaseParty;
      } else
        return this.getBasicCaseParty(basicCaseParty.relatedCasePartyID);
    },
  },
};
</script>
